import { createContext, useState, useContext, useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { widgetTypeState, widgetTypes } from '../states';
import { vocalTemplate } from '../states/constants';

type IProps = {
  children: React.ReactNode;
};

type ContextProps = {
  vocalValidated: boolean;
  onRemoveRcord(): void;
  onSaveTemplate(record: string): void;
  onCancelAddVoice(): void;
  template?: string | null;
  operationId?: string;
};

const Ctx = createContext<ContextProps>({
  vocalValidated: false,
  onRemoveRcord: () => {},
  onSaveTemplate: () => {},
  onCancelAddVoice: () => {},
  template: null,
});

export const VocalProvider = ({ children }: IProps) => {
  const [vocalValidated, setVocalValidated] = useState<boolean>(
    !!localStorage.getItem(vocalTemplate)
  );

  const setWidgetType = useSetRecoilState(widgetTypeState);

  const [template, setTemplate] = useState<string | null>(
    localStorage.getItem(vocalTemplate)
  );

  useEffect(() => {
    if (template) {
      setVocalValidated(true);
    }
  }, [template]);

  const onSaveTemplate = (record: string) => {
    setTemplate(record);
    localStorage.setItem(vocalTemplate, record);
  };

  const onRemoveRcord = () => {
    setTemplate(null);
    setVocalValidated(false);
    localStorage.removeItem(vocalTemplate);
  };

  const onCancelAddVoice = () => {
    setVocalValidated(false);
    setWidgetType(widgetTypes.facial);
  };

  return (
    <Ctx.Provider
      value={{
        vocalValidated,
        onRemoveRcord,
        onSaveTemplate,
        onCancelAddVoice,
        template,
      }}
    >
      {children}
    </Ctx.Provider>
  );
};

export const useVocalAuth = () => useContext(Ctx);
